import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadIndividualConsultationDocuments, deleteIndividualConsultationDocument } from './actions';
import List from './List';
import authUtils from '../../auth/utils';

class IndividualConsultationDocuments extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		this.reloadData();
	}

	handleListEvent(listPagination) {
		const paymentId = this.props.paymentId;
		this.props.loadData({ paymentId, ...listPagination });
	}

	handleDelete(id) {
		this.props.deleteIndividualConsultationDocument(id, () => this.reloadData());
	}

	reloadData() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const paymentId = this.props.paymentId;
		this.props.loadData({ paymentId, sortKey, sortDirection, pageNumber, pageSize });
	}

	render() {
		return (
			<List isReadonly={this.props.isReadonly} onFetchData={this.handleListEvent} data={this.props.data} onDelete={this.handleDelete} {...this.props.pagination} {...this.props} />
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { individualConsultationDocuments },
		auth: { currentUser } } = state;

	const individualConsultationDocumentsPagination = pagination.individualConsultationDocuments[ownProps.paymentId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: individualConsultationDocumentsPagination.ids.map(id => individualConsultationDocuments[id]),
		pagination: individualConsultationDocumentsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultationDocuments')
	};
};

IndividualConsultationDocuments.propTypes = {
	paymentId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadIndividualConsultationDocuments,
	deleteIndividualConsultationDocument
})(IndividualConsultationDocuments);